/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

export default () => {
    const [scrollY, setScrollY] = React.useState(0);

    React.useEffect(() => {
        if (typeof window === 'undefined') {
            return;
        }
        let ticking = false;

        const onScroll = () => {
            if (!ticking) {
                requestAnimationFrame(() => {
                    setScrollY(window.scrollY || 0);
                    ticking = false;
                });
                ticking = true;
            }
        };

        onScroll();
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    return (
        <div onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className={`back-to-top ${scrollY > 200 ? '' : 'hidden'}`}>
            <i className='fa-arrow-up' />
        </div>
    );
};
